import type { Match, PlayerLite } from "../state";
import { liveOrFinalPickPoints } from "../util";
import { Avatar } from "./Avatar";
import { TeamBadge } from "./TeamBadge";

export function PredictionPills({
  match,
  players,
}: {
  match: Match;
  players: PlayerLite[];
}) {
  if (!match.picks?.length) return null;

  return (
    <div className="picks-grid">
      {[...match.picks]
        .map((pick) => ({ pick, player: players.find((player) => player.id === pick.player_id) }))
        .filter((row) => row.player)
        .sort((a, b) => a.player!.name.localeCompare(b.player!.name))
        .map(({ pick, player }) => {
          const winnerCode = pick.predicted_winner === "home" ? match.home : match.away;
          const points = liveOrFinalPickPoints(pick, match, match.scoring);
          const classes = ["pick-pill"];
          if (points !== null) {
            if (points >= match.max_points) classes.push("pick-pill--bullseye");
            else if (points > 0) classes.push("pick-pill--winning");
          }

          return (
            <span className={classes.join(" ")} key={pick.player_id}>
              <Avatar name={player!.name} initials={player!.initials} color={player!.color} size="sm" />
              <span className="pick-pill__name">{player!.name}</span>
              <span className="pick-pill__score">{pick.home_score}-{pick.away_score}</span>
              {pick.predicted_winner && (
                <span className="pick-pill__winner">→ <TeamBadge code={winnerCode} compact /></span>
              )}
            </span>
          );
        })}
    </div>
  );
}
